/**
 * Параметры списка клиентов для админского GET /users.
 */
export interface ICustomersListQuery {
  limit?: number
  offset?: number
  first_name?: string
  last_name?: string
  phone?: string
  email?: string
  city?: string
  pizzeria_id?: number
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

/**
 * Собирает объект query-параметров списка клиентов, пропуская пустые значения.
 * Используется с axios `params` (без ручной сборки URL — корректный encode `@` в email).
 * @param query — фильтры, пагинация и сортировка
 * @returns объект для axios params или undefined
 */
export const buildCustomersQueryParamsObject = (
  query?: ICustomersListQuery,
): Record<string, string | number> | undefined => {
  if (!query) {
    return undefined
  }

  const params: Record<string, string | number> = {}

  Object.entries(query).forEach(([paramName, paramValue]) => {
    if (paramValue === undefined || paramValue === null) {
      return
    }
    if (typeof paramValue === 'string' && !paramValue.trim()) {
      return
    }
    params[paramName] = paramValue as string | number
  })

  return Object.keys(params).length > 0 ? params : undefined
}

/**
 * Собирает query-параметры списка клиентов в строку.
 * @param query — фильтры, пагинация и сортировка
 * @returns строка вида `?limit=20&offset=0&...` или пустая строка
 */
const buildCustomersQueryParams = (query?: ICustomersListQuery): string => {
  const paramsObject = buildCustomersQueryParamsObject(query)
  if (!paramsObject) {
    return ''
  }

  const searchParams = new URLSearchParams()
  Object.entries(paramsObject).forEach(([paramName, paramValue]) => {
    searchParams.set(paramName, String(paramValue))
  })

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

export default buildCustomersQueryParams
